import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavbarAndSidebar from "../pages/NavbarAndSidebar";
import CreateCertificate from "../pages/Certificate/CreateCertificate/CreateCertificate";
import ShowCertificate from "../pages/Certificate/ShowCertificate/ShowCertificate";
import ManagmentCarpet from "../pages/Carpet/ManagmentCarpet";
import FrequentlyServices from "../pages/FrequentlyServices/FrequentlyServices"
import CarpetCategory from "../pages/Carpet/CarpetCategory";
import Test from "../../src/Test/Test";

const ProjectRoutes = () => {
  return (
    <Router>
   <NavbarAndSidebar />

      <Routes>
      <Route index element={<FrequentlyServices />} />

        <Route path="/login" element={<Test />} />
        <Route path="/Certificate/Create-Certificate" element={<CreateCertificate />} />
        <Route path="/Certificate/Show-Certificate" element={<ShowCertificate />} />
        <Route path="/Carpet/Managment-Carpet" element={<ManagmentCarpet />} />
        <Route path="/Carpet/Create-Category" element={<CarpetCategory />} />
        {/* notfound page */}
        <Route path="*" element={<FrequentlyServices />} />

      </Routes>      

    </Router>
  );
};

export default ProjectRoutes;
